var _path, _textPath, _circle, _text, _text2, _text3, _text4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextAndAward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 124.72 124.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "rescale_container"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rosette_text",
    "data-type": "curved"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.8,96.4C29.5,89.3 22,76.7 22,62.4 C 22,40.1 40.1,22 62.4,22 C 82.7,22 102.8,40.1 102.8,62.4 c 0,14.5 -7.7,27.3 -19.2,34.4",
    fill: "none",
    stroke: "transparent",
    strokeMiterlimit: 10,
    id: "curve_path",
    "data-width": 80.8
  })), /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    style: {
      fontSize: 16,
      fill: "black"
    }
  }, _textPath || (_textPath = /*#__PURE__*/React.createElement("textPath", {
    startOffset: "50%",
    id: "curve_path",
    href: "#curve_path"
  }, "\n          YOUR TEXT HERE\n        ")))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62.36,
    cy: 62.36,
    r: 58.11,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.57,
    id: "plain_border"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "award_text_display",
    x: 62.36,
    y: 59.47,
    fontSize: "17.94px",
    isolation: "isolate",
    textAnchor: "middle"
  }, "AWARD")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "award_text_display",
    x: 62.36,
    y: 79.31,
    fontSize: "17.94px",
    isolation: "isolate",
    textAnchor: "middle"
  }, "HERE")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "award_text",
    x: 62.36,
    y: 73.89,
    fontSize: 35.88,
    isolation: "isolate",
    textAnchor: "middle",
    "data-max_count": 3,
    fill: "black",
    "data-max_length": 1.84
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "award_text",
    x: 62.36,
    y: 45.47,
    fontSize: 17.94,
    isolation: "isolate",
    textAnchor: "middle",
    "data-line_break": 3.3,
    "data-max_lines": 3,
    "data-max_length": 11.3,
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextAndAward);
export default __webpack_public_path__ + "static/media/text-and-award.1b600432c184d7241e6fabc1f85efd2b.svg";
export { ForwardRef as ReactComponent };